// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BDAzh","left":"styles_left__9kdBe"};